<template lang="pug">
.monster.monster-wrapper.align-items-center
  .col-3
    .circle(@click='selectMonster()')
      img.favorite(v-if='sprite._id === favoriteMonster._id', src='../../assets/favorite-yellow.svg')
      sprite-render(:sprite='sprite')
      .view-sprite View
  .col-9
    .monster
      .d-flex.justify-content-between
        .monster-name(v-if='!sprite.tokenId') {{ sprite.name }}
        .monster-name(v-else-if='sprite.name') {{ sprite.name }}
        .monster-name(v-else) Sprite {{`#${sprite.tokenId}`}}
        .new-actions(v-if='filteredActivity.length > 0') New Actions!
      .progress-wrap
        .progress-item
          .exp-fill(:style="{width: `${expPercent}%`}")
      .d-flex.justify-content-between
        .level Level {{ sprite.level || 0 }}
        .float-right.exp-list {{ spriteExp - expToPrevLevel }} / {{ expToNextLevel - expToPrevLevel }} EXP
      //.energy-wrap
        strong Energy:
        img(v-for='n in 6', src='../../assets/energy.svg', :class="{active: n === 1}")
</template>

<style lang="scss" scoped>
  .circle {
    border-radius: 8px;
    padding: 1em;
    background-color: #f7f8f6;
    background: #F3F5F7;
    margin: 0 auto;
    position: relative;
  }

  .favorite {
    position: absolute;
    top: .5rem;
    right: .5rem;
  }

  // Share EXP
  .progress-wrap {
    position: relative;
  }

  .progress-item {
    width: 100%;
    max-width: 375px;
    height: 8px;
    border-radius: 999px;
    background-color: #d7dad2;
    margin: 0 auto;
  }

  .exp-fill {
    width: 84px;
    max-width: 100%;
    height: 8px;
    border-radius: 999px;
    background-color: #33d238;
  }

  .exp {
    margin: 0 auto;
    width: 150px;
    // font-family: ProximaSoft;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: 0.5px;
    text-align: center;
    color: #6c6d69;
    margin-top: .5em;
    margin-bottom: .5em;
  }

  .energy-wrap {
    margin-top: .5em;
    margin-bottom: 1em;

    img {
      width: 15.5px;
      margin-right: .3rem;
    }

    strong {
      text-transform: uppercase;
      font-size: 12px;
      color: #6c6d69;
    }
  }

  // Share EXP

  .card {
    height: 100%;
    background: #fff;
    border: none;
  }

  .monster-wrapper {
    margin-bottom: 1.714em;
  }

  .monster {
    font-size: 14px;

    .monster-name {
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #363734;
    }

    .new-actions {
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #3ba5a8;
    }

    .level {
      font-family: Nunito;
      font-size: 12px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: 0.5px;
      color: #6c6d69;
      text-transform: uppercase;
    }

    .exp-list {
      font-family: Nunito;
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: 0.5px;
      text-align: right;
      color: #6c6d69;
    }

    .energy-wrap {
      strong {
        vertical-align: sub;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        color: #6c6d69;
        margin-right: .3em;
      }

      img {
        margin-left: .2em;
        opacity: 0.24;
        height: 16px;
      }

      img.active {
        opacity: 1;
      }
    }

    div {
      margin-bottom: .2em;
    }

    .progress-bar {
      margin-bottom: 0;
    }

    .actions {
      font-size: 12px;
      background: #F3F5F7;
      width: 100%;
      border-radius: 4px;
      text-align: center;
      margin: 0 auto;
      padding: .2em;
    }
  }

  .view-sprite {
    margin-bottom: 0 !important;
    opacity: 0;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: .3em .5em;
    border-radius: 0  0 8px 8px;
    background-color: #3ba5a8;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #f7f8f6;
  }

  .circle:hover {
    cursor: pointer;
  }

  .circle:hover .view-sprite {
    opacity: 1;
    transition: opacity ease .5s;
  }
</style>

<script>
import moment from 'moment';
import SpriteRender from './SpriteRender';
import spriteStats from '../../mixins/spriteStats';

export default {
  props: ['sprite'],
  mixins: [spriteStats],
  components: {
    SpriteRender,
  },
  computed: {
    favoriteMonster() {
      return this.$store.state.favoriteMonster;
    },
    viewedActivityDates() {
      return this.$store.state.viewedActivityDates;
    },
    filteredActivity() {
      const lastViewedDate = this.viewedActivityDates[this.sprite._id];

      if (!this.sprite.recentActivity) return [];

      const activity = this.sprite.recentActivity.filter((act) => {
        return lastViewedDate ? moment(lastViewedDate).isBefore(act.createdAt) : true;
      });

      return activity;
    },
  },
  methods: {
    selectMonster() {
      this.$root.$emit('show-sprite-detail', { sprite: this.sprite });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/monsters/SpriteListItem.vue